import { assertType } from '../assert-type';
export const tp = (...args) => args;
const tuple = tp(1, 2, 3);
assertType();
